var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowRight = function SvgIconArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M9.675 21.825a1.167 1.167 0 0 1 0-1.65l6.759-6.758-6.759-6.759a1.167 1.167 0 0 1 1.65-1.65l6.759 6.759a2.333 2.333 0 0 1 0 3.3l-6.759 6.758a1.166 1.166 0 0 1-1.65 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconArrowRight;